var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { GET_NEWSLETTER, GET_NEWSLETTER_SUCCESS, GET_NEWSLETTER_ERROR, GET_NEWSLETTERS, GET_NEWSLETTERS_SUCCESS, GET_NEWSLETTERS_ERROR, GET_SUBSCRIPTION } from "../../constants/actionTypes";

var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_NEWSLETTER:
    case GET_NEWSLETTERS:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case GET_NEWSLETTER_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: action.payload
        });
      }

    case GET_NEWSLETTERS_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case GET_NEWSLETTER_ERROR:
    case GET_NEWSLETTERS_ERROR:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    case GET_SUBSCRIPTION:
      {
        return _extends({}, state, {
          data: null
        });
      }

    default:
      {
        return state;
      }
  }
});


// WEBPACK FOOTER //
// ./src/subscriptions/reducers/newsletters.js